import { mapActions, mapState } from 'vuex'
import AttendedPresentationsApi from '@/api/attended-presentations'
import * as Sentry from '@sentry/vue'

export default {
  computed: {
    ...mapState({
      presentation: (state) => state.presentation,
      currentUser: (state) => state.currentUser,
      audienceId: (state) => state.audienceId,
    }),
    isPresentationLoaded() {
      return this.presentation && this.presentation.id
    },
    isUserLoggedIn() {
      return this.currentUser && this.currentUser.id
    },
    isUserAndPresentationLoaded() {
      return this.isUserLoggedIn && this.isPresentationLoaded
    },
  },
  watch: {
    isUserLoggedIn: {
      handler(value) {
        if (value) {
          document.body.classList.add('user-logged')
        }
      },
      immediate: true,
    },
    isUserAndPresentationLoaded: {
      handler(value) {
        if (value) {
          this.createNewAttendedPresentation({
            presentationId: this.presentation && this.presentation.id,
          })
        }
      },
      immediate: true,
    },
  },
  methods: {
    ...mapActions(['setIsCreatedNewAttendedAction']),
    async createNewAttendedPresentation({ presentationId }) {
      if (this.currentUser && this.currentUser.isGuest) return

      try {
        const localStorageKeyForAttendedPresentation = `aha-attended-presentation-${this.currentUser.id}-${presentationId}`

        let hasAttendedLocally = false

        if (typeof localStorage !== 'undefined') {
          hasAttendedLocally = localStorage.getItem(localStorageKeyForAttendedPresentation)
        }

        if (hasAttendedLocally) return

        await AttendedPresentationsApi.createAttendedPresentation({ presentationId })

        if (typeof localStorage !== 'undefined') {
          localStorage.setItem(localStorageKeyForAttendedPresentation, 'true')
        }
      } catch (err) {
        Sentry.captureException(err)
      } finally {
        // set flag to prevent multiple requests
        this.setIsCreatedNewAttendedAction(true)
      }
    },
  },
}
